export default {
  intersect(a, b) {
    // const result = a.filter(x => b.includes(x));
    const result = window._.intersection(a, b);
    return result;
  },
  replaceMap(collection, identity, replacement) {
    var index = window._.indexOf(collection, window._.find(collection, identity));
    // console.log(collection,replacement);
    collection.splice(index, 1, replacement);
    return collection;
  },
  searchByIdentityAndChangeAnyValue(collection, identity, objNewValue) {
    var index = window._.indexOf(collection, window._.find(collection, identity));
    for (let key in objNewValue) {
      collection[index][key] = objNewValue[key];
    }
    return collection;
  },
  arrayToText(x) {
    return x.join();
  },
};

export function isNotEmpty(s) {
  return s && s.length && s.length > 0;
}
